import axios from 'axios';
import { getDataFromLocalStorage, localStorageData, setDataToLocalStorage } from './localStorage';
import { CUSTOM_HEADERS } from '../constants/custom-headers';
import { HTTP_STATUS } from '../constants/http-codes-error-msg';
import store from '../redux';
import { messageAuth } from './errorHandler';
import { getTabId } from '../hooks/useSocketRegistration';
import { axiosInstance } from './../api/baseApi';

export const formatAuthHeader = (token) => {
  if (!token) return '';
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

const refreshAxios = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  withCredentials: true
});

class ApiInterceptor {
  constructor() {
    this.isRefreshing = false;
    this.pendingRequests = [];
    this.setupInterceptors();
  }

  setupInterceptors() {
    axiosInstance.interceptors.request.use(
      (config) => {
        const user = getDataFromLocalStorage(localStorageData.user);
        if (user) {
          config.headers[CUSTOM_HEADERS.Authorization] = formatAuthHeader(user.accessToken);
          config.headers[CUSTOM_HEADERS.DeviceId] = user.deviceId;
          config.headers[CUSTOM_HEADERS.TabId] = getTabId();
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === HTTP_STATUS.UNAUTHORIZED && !originalRequest._retry) {
          if (this.isRefreshing) {
            // Если уже идет процесс обновления токена, добавляем запрос в очередь
            return new Promise((resolve) => {
              this.pendingRequests.push(() => {
                resolve(axiosInstance(originalRequest));
              });
            });
          }

          originalRequest._retry = true;
          this.isRefreshing = true;

          try {
            const user = getDataFromLocalStorage(localStorageData.user);

            if (!user) {
              return Promise.reject({
                ...error,
                handled: true
              });
            }

            const refreshResponse = await refreshAxios.post('/auth/refreshtoken/');

            const newToken = refreshResponse.headers[CUSTOM_HEADERS.AccessToken];

            if (newToken) {
              // Обновляем токены в localStorage
              const updatedUser = {
                ...user,
                accessToken: newToken
              };

              setDataToLocalStorage(localStorageData.user, updatedUser);

              // Обновляем заголовок в оригинальном запросе
              originalRequest.headers[CUSTOM_HEADERS.Authorization] = formatAuthHeader(newToken);

              // Выполняем все отложенные запросы
              this.resolvePendingRequests();

              // Повторяем оригинальный запрос
              return axiosInstance(originalRequest);
            } else {
              return Promise.reject({
                ...error,
                handled: true
              });
            }

          } catch (refreshError) {
            this.handleAuthFailure();
            return Promise.reject(refreshError);
          } finally {
            this.isRefreshing = false;
          }
        }

        return Promise.reject(error);
      }
    );
  }

  handleAuthFailure() {
    console.log("handleAuthFailure");
    setDataToLocalStorage(localStorageData.isShowMessageAuth, 1);
    messageAuth();
  }

  resolvePendingRequests() {
    this.pendingRequests.forEach((callback) => callback());
    this.pendingRequests = [];
  }

}

export const apiInterceptor = new ApiInterceptor();